// TODO: Refactor the module to reduce duplicates.
// TODO: Use async-await instead of promises.

import axios from 'axios';

import { HOST_PORTAL_FQDN } from '@/services/connections.service';
import { COOKIE_MAP } from '@/services/cookie.service';
import { getAuthToken } from '@/services/identity.service';

Object.assign(axios.defaults.headers.common, {
  'content-type': 'application/json',
  'x-origin-domain': HOST_PORTAL_FQDN
});

export const getWithoutAuth = (url) =>
  new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((ex) => {
        reject(ex);
      });
  });

export const postWithoutAuth = (url, entity) =>
  new Promise((resolve, reject) => {
    axios
      .post(url, entity)
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((ex) => {
        reject(ex);
      });
  });

export const deleteWithoutAuth = (url, entity) =>
  new Promise((resolve, reject) => {
    axios
      .delete(url, {
        data: entity
      })
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((ex) => {
        reject(ex);
      });
  });

const getOptionsForWithAuth = (tokenOverride) => {
  const token = tokenOverride || getAuthToken();
  const options = {
    headers: {},
    withCredentials: true
  };

  if (token) {
    options.headers['x-access-token'] = token;
  }

  return options;
};

export const getWithAuth = (url, tokenOverride, extraConfig = {}) => {
  const withAuthOptions = getOptionsForWithAuth(tokenOverride);
  const options = {
    ...withAuthOptions,
    ...extraConfig,
    headers: {
      ...withAuthOptions.headers,
      ...extraConfig.headers
    }
  };
  return new Promise((resolve, reject) => {
    axios
      .get(url, options)
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((ex) => {
        reject(ex);
      });
  });
};

export const postWithAuth = (url, entity) => {
  const withAuthOptions = getOptionsForWithAuth();
  return new Promise((resolve, reject) => {
    axios
      .post(url, entity, withAuthOptions)
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((ex) => {
        reject(ex);
      });
  });
};

// Note: We use dynamic import for 'next/headers' because this file is shared between
// Server and Client components. Top-level import would break client-side builds.
export const executeServerApiWithAuth = async ({ apiFn, params = {} }) => {
  const { cookies } = await import('next/headers');
  const cookieStore = await cookies();

  const authCookie = cookieStore.get(
    COOKIE_MAP.HOST_PORTAL_USER_IDENTITY
  )?.value;

  const token = authCookie ? JSON.parse(authCookie)?.token : null;

  const cookieHeader = cookieStore
    .getAll()
    .map((cookie) => `${cookie.name}=${cookie.value}`)
    .join('; ');

  const response = await apiFn({
    ...params,
    token,
    headers: {
      Cookie: cookieHeader
    }
  });

  return response;
};
